import $ from 'jquery';
import debug from 'debug';
const log = debug('linksoft:datatables:fixedHeader');
const DataTable = $.fn.dataTable;
let _instCounter = 0;

function closestScrollable(el) {
	let scrollable = $(el).parents().filter((i, n) => n.scrollHeight > n.clientHeight).get(0);
	if (scrollable === document.body) {
		scrollable = document;
	}
	return scrollable || document;
}

const FixedHeader = function (dt, config) {
	// Sanity check - you just know it will happen
	if (!(this instanceof FixedHeader)) {
		throw "FixedHeader must be initialised with the 'new' keyword.";
	}

	// Allow a boolean true for defaults
	if (config === true) {
		config = {};
	}

	dt = new DataTable.Api(dt);

	this.c = $.extend(true, {}, FixedHeader.defaults, config);

	this.s = {
		dt: dt,
		position: {
			theadTop: 0,
			tbodyTop: 0,
			tfootTop: 0,
			tfootBottom: 0,
			width: 0,
			left: 0,
			tfootHeight: 0,
			theadHeight: 0,
			scrollable: null,
			scrollableHeight: 0,
			visible: true
		},
		headerMode: null,
		footerMode: null,
		autoWidth: dt.settings()[0].oFeatures.bAutoWidth,
		namespace: '.dtfc' + (_instCounter++),
		scrollLeft: {
			header: -1,
			footer: -1
		},
		enable: true
	};

	this.dom = {
		floatingHeader: null,
		thead: $(dt.table().header()),
		tbody: $(dt.table().body()),
		tfoot: $(dt.table().footer()),
		header: {
			host: null,
			floating: null,
			placeholder: null
		},
		footer: {
			host: null,
			floating: null,
			placeholder: null
		}
	};

	this.dom.header.host = this.dom.thead.parent();
	this.dom.footer.host = this.dom.tfoot.parent();

	const dtSettings = dt.settings()[0];
	if (dtSettings._fixedHeader) {
		throw "FixedHeader already initialised on table " + dtSettings.nTable.id;
	}

	dtSettings._fixedHeader = this;

	this._constructor();
};


/*
 * Variable: FixedHeader
 * Purpose:  Prototype for FixedHeader
 * Scope:    global
 */
$.extend(FixedHeader.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * API methods
	 */

	/**
	 * Enable / disable the fixed elements
	 *
	 * @param  {boolean} enable `true` to enable, `false` to disable
	 */
	enable: function (enable) {
		this.s.enable = enable;

		if (this.c.header) {
			this._modeChange('in-place', 'header', true);
		}

		if (this.c.footer && this.dom.tfoot.length) {
			this._modeChange('in-place', 'footer', true);
		}

		this.update();
	},

	/**
	 * Set header offset
	 *
	 * @param  {int} new value for headerOffset
	 */
	headerOffset: function (offset) {
		if (offset !== undefined) {
			this.c.headerOffset = offset;
			this.update();
		}

		return this.c.headerOffset;
	},

	/**
	 * Set footer offset
	 *
	 * @param  {int} new value for footerOffset
	 */
	footerOffset: function (offset) {
		if (offset !== undefined) {
			this.c.footerOffset = offset;
			this.update();
		}

		return this.c.footerOffset;
	},


	/**
	 * Recalculate the position of the fixed elements and force them into place
	 */
	update: function () {
		this._positions();
		this._scroll(true);
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */

	/**
	 * FixedHeader constructor - adding the required event listeners and
	 * simple initialisation
	 *
	 * @private
	 */
	_constructor: function () {
		const that = this;
		const dt = this.s.dt;

		this._setupScrollHandler();

		const autoHeader = $('.fh-fixedHeader');
		if (!this.c.headerOffset && autoHeader.length) {
			this.c.headerOffset = autoHeader.outerHeight();
		}

		const autoFooter = $('.fh-fixedFooter');
		if (!this.c.footerOffset && autoFooter.length) {
			this.c.footerOffset = autoFooter.outerHeight();
		}

		dt.on('column-reorder.dt.dtfc column-visibility.dt.dtfc draw.dt.dtfc column-sizing.dt.dtfc', function () {
			that.update();
		});

		dt.on('destroy.dtfc', function () {
			dt.off('.dtfc');
			$(that.d.position.scrollable).off(that.s.namespace);
		});

		this._positions();
		this._scroll();
	},


	_setupScrollHandler: function () {
		const position = this.s.position;
		const scrollable = position.scrollable;
		position.scrollable = closestScrollable(this.s.dt.table().container());
		position.scrollableHeight = $(position.scrollable).height();
		position.scrollableFixed = position.scrollable != document && $(position.scrollable).css('position') === 'fixed';
		if (scrollable !== position.scrollable) {
			$(scrollable).off(this.s.namespace);
			$(position.scrollable)
					.on('scroll' + this.s.namespace, () => {
						this._scroll();
					})
					.on('resize' + this.s.namespace, () => {
						this.s.position.scrollableHeight = $(scrollable).height();
						this.update();
					});
		}
		this._positions();
		this._scroll();
	},

	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */

	/**
	 * Clone a fixed item to act as a place holder for the original element
	 * which is moved into a clone of the table element, and moved around the
	 * document to give the fixed effect.
	 *
	 * @param  {string}  item  'header' or 'footer'
	 * @param  {boolean} force Force the clone to happen, or allow automatic
	 *   decision (reuse existing if available)
	 * @private
	 */
	_clone: function (item, force) {
		const dt = this.s.dt;
		const itemDom = this.dom[item];
		const itemElement = item === 'header' ?
				this.dom.thead :
				this.dom.tfoot;

		if (!force && itemDom.floating) {
			// existing floating element - reuse it
			itemDom.floating.removeClass('fixedHeader-floating fixedHeader-locked');
		}
		else {
			if (itemDom.floating) {
				itemDom.placeholder.remove();
				this._unsize(item);
				itemDom.floating.children().detach();
				itemDom.floating.remove();
			}

			itemDom.floating = $(dt.table().node().cloneNode(false))
					.css('table-layout', 'fixed')
					.removeAttr('id')
					.append(itemElement)
					.appendTo(dt.table().container());

			// Insert a fake thead/tfoot into the DataTable to stop it jumping around
			itemDom.placeholder = itemElement.clone(false);
			itemDom.placeholder
					.find('*[id]')
					.removeAttr('id');

			itemDom.host.prepend(itemDom.placeholder);

			// Clone widths
			this._matchWidths(itemDom.placeholder, itemDom.floating);
		}
	},

	/**
	 * Copy widths from the cells in one element to another. This is required
	 * for the footer as the footer in the main table takes its sizes from the
	 * header columns. That isn't present in the footer so to have it still
	 * align correctly, the sizes need to be copied over. It is also required
	 * for the header when auto width is not enabled
	 *
	 * @param  {jQuery} from Copy widths from
	 * @param  {jQuery} to   Copy widths to
	 * @private
	 */
	_matchWidths: function (from, to) {
		const get = function (name) {
			return $(name, from)
					.map(function () {
						return $(this).width();
					}).toArray();
		};

		const set = function (name, toWidths) {
			$(name, to).each(function (i) {
				$(this).css({
					width: toWidths[i],
					minWidth: toWidths[i]
				});
			});
		};

		const thWidths = get('th');
		const tdWidths = get('td');

		set('th', thWidths);
		set('td', tdWidths);
	},

	/**
	 * Remove assigned widths from the cells in an element. This is required
	 * when inserting the footer back into the main table so the size is defined
	 * by the header columns and also when auto width is disabled in the
	 * DataTable.
	 *
	 * @param  {string} item The `header` or `footer`
	 * @private
	 */
	_unsize: function (item) {
		const el = this.dom[item].floating;

		if (el && (item === 'footer' || (item === 'header' && !this.s.autoWidth))) {
			$('th, td', el).css({
				width: '',
				minWidth: ''
			});
		}
		else if (el && item === 'header') {
			$('th, td', el).css('min-width', '');
		}
	},

	/**
	 * Reposition the floating elements to take account of horizontal page
	 * scroll
	 *
	 * @param  {string} item       The `header` or `footer`
	 * @param  {int}    scrollLeft Document scrollLeft
	 * @private
	 */
	_horizontal: function (item, scrollLeft) {
		const itemDom = this.dom[item];
		const position = this.s.position;
		const lastScrollLeft = this.s.scrollLeft;

		if (itemDom.floating && lastScrollLeft[item] !== scrollLeft) {
			itemDom.floating.css('left', position.left - scrollLeft);

			lastScrollLeft[item] = scrollLeft;
		}
	},

	/**
	 * Change from one display mode to another. Each fixed item can be in one
	 * of:
	 *
	 * * `in-place` - In the main DataTable
	 * * `in` - Floating over the DataTable
	 * * `below` - (Header only) Fixed to the bottom of the table body
	 * * `above` - (Footer only) Fixed to the top of the table body
	 *
	 * @param  {string}  mode        Mode that the item should be shown in
	 * @param  {string}  item        'header' or 'footer'
	 * @param  {boolean} forceChange Force a redraw of the mode, even if already
	 *     in that mode.
	 * @private
	 */
	_modeChange: function (mode, item, forceChange) {
		const dt = this.s.dt;
		const itemDom = this.dom[item];
		const position = this.s.position;

		// Record focus. Browser's will cause input elements to loose focus if
		// they are inserted else where in the doc
		const tablePart = this.dom[item === 'footer' ? 'tfoot' : 'thead'];
		const focus = $.contains(tablePart[0], document.activeElement) ?
				document.activeElement :
				null;

		if (mode === 'in-place') {
			// Insert the header back into the table's real header
			if (itemDom.placeholder) {
				itemDom.placeholder.remove();
				itemDom.placeholder = null;
			}

			this._unsize(item);

			if (item === 'header') {
				itemDom.host.prepend(this.dom.thead);
			}
			else {
				itemDom.host.append(this.dom.tfoot);
			}

			if (itemDom.floating) {
				itemDom.floating.remove();
				itemDom.floating = null;
			}
		}
		else if (mode === 'in') {
			// Remove the header from the read header and insert into a fixed
			// positioned floating table clone
			this._clone(item, forceChange);

			itemDom.floating
					.addClass('fixedHeader-floating')
					.css(item === 'header' ? 'top' : 'bottom', this.c[item + 'Offset'])
					.css('left', 0) // position.left + 'px'
					.css('width', position.width + 'px');

			if (item === 'footer') {
				itemDom.floating.css('top', '100px');
			}
		}
		// else if (mode === 'below') { // only used for the header
		// 	// Fix the position of the floating header at base of the table body
		// 	this._clone(item, forceChange);
		//
		// 	itemDom.floating
		// 			.addClass('fixedHeader-locked')
		// 			.css('top', position.tfootTop - position.theadHeight)
		// 			.css('left', position.left + 'px')
		// 			.css('width', position.width + 'px');
		// }
		// else if (mode === 'above') { // only used for the footer
		// 	// Fix the position of the floating footer at top of the table body
		// 	this._clone(item, forceChange);
		//
		// 	itemDom.floating
		// 			.addClass('fixedHeader-locked')
		// 			.css('top', position.tbodyTop)
		// 			.css('left', position.left + 'px')
		// 			.css('width', position.width + 'px');
		// }

		// Restore focus if it was lost
		if (focus && focus !== document.activeElement) {
			focus.focus();
		}

		this.s.scrollLeft.header = -1;
		this.s.scrollLeft.footer = -1;
		this.s[item + 'Mode'] = mode;
	},

	/**
	 * Cache the positional information that is required for the mode
	 * calculations that FixedHeader performs.
	 *
	 * @private
	 */
	_positions: function () {
		const dt = this.s.dt;
		const table = dt.table();
		const position = this.s.position;
		const dom = this.dom;
		const tableNode = $(table.node());
		const windowTop = $(window).scrollTop();

		// Need to use the header and footer that are in the main table,
		// regardless of if they are clones, since they hold the positions we
		// want to measure from
		const thead = tableNode.children('thead');
		const tfoot = tableNode.children('tfoot');
		const tbody = dom.tbody;

		position.visible = tableNode.is(':visible');
		position.width = tableNode.outerWidth();
		position.left = 0; //tableNode.offset().left;
		position.theadTop = thead.offset().top;
		position.tbodyTop = tbody.offset().top;
		if(position.scrollableFixed) {
			position.theadTop -= windowTop;
			position.tbodyTop -= windowTop;
		}
		position.theadHeight = position.tbodyTop - position.theadTop;

		if (tfoot.length) {
			position.tfootTop = tfoot.offset().top;
			position.tfootBottom = position.tfootTop + tfoot.outerHeight();
			position.tfootHeight = position.tfootBottom - position.tfootTop;
		}
		else {
			position.tfootTop = position.tbodyTop + tbody.outerHeight();
			position.tfootBottom = position.tfootTop;
			position.tfootHeight = position.tfootTop;
		}
	},


	/**
	 * Mode calculation - determine what mode the fixed items should be placed
	 * into.
	 *
	 * @param  {boolean} forceChange Force a redraw of the mode, even if already
	 *     in that mode.
	 * @private
	 */
	_scroll: function (forceChange = false) {
		const position = this.s.position;
		const windowTop = $(position.scrollable).scrollTop() || 0;
		const windowLeft = $(position.scrollable).scrollLeft() || 0;
		let headerMode, footerMode;

		if (!this.s.enable) {
			return;
		}

		if (this.c.header) {
			if(position.visible && (windowTop > position.theadTop - this.c.headerOffset || position.theadTop < 0)) {
				headerMode = 'in';
			}
			else {
				headerMode = 'in-place';
			}

			if (forceChange || headerMode !== this.s.headerMode) {
				this._modeChange(headerMode, 'header', forceChange);
			}

			this._horizontal('header', windowLeft);

			if (headerMode === 'in') {
				if(!position.scrollableFixed) {
					const containerTop = $(this.s.dt.table().container()).offset().top;
					$(this.dom.header.floating).css('top', windowTop - containerTop);
				} else {
					const containerTop = $(this.s.dt.table().container()).position().top;
					$(this.dom.header.floating).css('top', -containerTop);
				}
			}
		}

		if (this.c.footer && this.dom.tfoot.length) {
			if (!position.visible || windowTop + position.scrollableHeight >= position.tfootBottom + this.c.footerOffset) {
				footerMode = 'in-place';
			}
			else if (position.scrollableHeight + windowTop > position.tbodyTop + position.tfootHeight + this.c.footerOffset) {
				footerMode = 'in';
			}
			else {
				footerMode = 'above';
			}

			if (forceChange || footerMode !== this.s.footerMode) {
				this._modeChange(footerMode, 'footer', forceChange);
			}

			this._horizontal('footer', windowLeft);
		}
	}
});


/**
 * Version
 * @type {String}
 * @static
 */
FixedHeader.version = "3.1.3-dev";

/**
 * Defaults
 * @type {Object}
 * @static
 */
FixedHeader.defaults = {
	header: true,
	footer: false,
	headerOffset: 0,
	footerOffset: 0
};


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables interfaces
 */

// Attach for constructor access
$.fn.dataTable.FixedHeader = FixedHeader;
$.fn.DataTable.FixedHeader = FixedHeader;


// DataTables creation - check if the FixedHeader option has been defined on the
// table and if so, initialise
$(document).on('init.dt.dtfh', function (e, settings, json) {
	if (e.namespace !== 'dt') {
		return;
	}

	const init = settings.oInit.fixedHeader;
	const defaults = DataTable.defaults.fixedHeader;

	if ((init || defaults) && !settings._fixedHeader) {
		const opts = $.extend({}, defaults, init);

		if (init !== false) {
			new FixedHeader(settings, opts);
		}
	}
});

// DataTables API methods
DataTable.Api.register('fixedHeader()', function () {
});

DataTable.Api.register('fixedHeader.rewire()', function () {
	return this.iterator('table', function (ctx) {
		const fh = ctx._fixedHeader;
		if (fh) {
			fh._setupScrollHandler();
		}
	});
});

DataTable.Api.register('fixedHeader.adjust()', function () {
	return this.iterator('table', function (ctx) {
		const fh = ctx._fixedHeader;

		if (fh) {
			fh.update();
		}
	});
});

DataTable.Api.register('fixedHeader.enable()', function (flag) {
	return this.iterator('table', function (ctx) {
		const fh = ctx._fixedHeader;

		if (fh) {
			fh.enable(flag !== undefined ? flag : true);
		}
	});
});

DataTable.Api.register('fixedHeader.disable()', function () {
	return this.iterator('table', function (ctx) {
		const fh = ctx._fixedHeader;

		if (fh) {
			fh.enable(false);
		}
	});
});

$.each(['header', 'footer'], function (i, el) {
	DataTable.Api.register('fixedHeader.' + el + 'Offset()', function (offset) {
		const ctx = this.context;

		if (offset === undefined) {
			return ctx.length && ctx[0]._fixedHeader ?
					ctx[0]._fixedHeader[el + 'Offset']() :
					undefined;
		}

		return this.iterator('table', function (ctx) {
			const fh = ctx._fixedHeader;

			if (fh) {
				fh[el + 'Offset'](offset);
			}
		});
	});
});

function getDistance(element, ancestor) {
	const parent = $(element).parent();
	const position = $(element).position();
	if(position) {
		if (!parent.is(ancestor)) {
			const nextPosition = getDistance(parent, ancestor);
			if(!nextPosition) return nextPosition;
			position.top += nextPosition.top;
			position.left += nextPosition.left;
		}
	}
	return position;
}

export default FixedHeader;




// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables-fixedheader/src/index.js